import type { DocumentNode, OperationDefinitionNode } from 'graphql';

/**
 * Gets the operation name from a graphql document.
 */
export const getOperationNameFromDocument = (document: DocumentNode): string | undefined => {
  const operation = document.definitions.find((definition) => definition.kind === 'OperationDefinition');
  return (operation as OperationDefinitionNode)?.name?.value;
};
